// Formatting for the rolling 24h driving limit (Lei 45/2018, art. 13).

export const formatDrivingDuration = (seconds: number): string => {
  const totalMinutes = Math.max(0, Math.floor(seconds / 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours === 0) return `${minutes} min`;
  return `${hours} h ${String(minutes).padStart(2, '0')} min`;
};

export const formatLimitHours = (seconds: number, language?: string): string => {
  const hours = seconds / 3600;
  if (Number.isInteger(hours)) return String(hours);
  const text = hours.toFixed(1);
  // Portuguese uses a decimal comma ("9,5 h").
  return language?.startsWith('en') ? text : text.replace('.', ',');
};

// A status older than this is no longer shown: it is only refreshed while a
// session is open, and the rolling window keeps moving after it closes.
export const DRIVING_LIMIT_STALE_MS = 10 * 60 * 1000;

export const isDrivingLimitStale = (calculatedAt: string, nowMs: number = Date.now()): boolean => {
  const at = new Date(calculatedAt).getTime();
  return Number.isNaN(at) || nowMs - at > DRIVING_LIMIT_STALE_MS;
};

export const formatClock = (iso: string): string | null => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};
